<template>
    <div class="e6-flank-fix">
        <div class="fix-left" v-if="this.$slots.default">
            <div class="fix-left__content">
                <slot></slot>
            </div>
        </div>
        <div class="fix-right" v-if="this.$slots.fixRight">
            <div class="fix-right__content">
                <slot name="fixRight"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "E6FlankFix"
    };
</script>
